import React from "react";
import "./PremiumButton.css";
import { Link } from "react-router-dom";

function PremiumButton(props) {
	return (
		<div>
			<Link className="button btn-premium" to={props.target}>
				{" "}
				Try Premium{" "}
			</Link>
		</div>
	);
}

export default PremiumButton;
